import script from "./NewsPublic.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPublic.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/clubstyle.css?vue&type=style&index=0&lang=css&external"
import "./NewsPublic.vue?vue&type=style&index=1&id=54d3cf3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d3cf3c"]])

export default __exports__